import { useDispatch, useSelector } from 'react-redux';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import { useEffect, useCallback } from 'react';
import FJMobileDefaultPreview from '../FJMainPreview/FJMobileDefaultPreview/FJMobileDefaultPreview';
import useLocalStore from '../../hooks/useLocalStore';
import FJActionObjectErase from '../../redux/action/FJActionObjectErase';
import FJConfig from '../../config/FJConfig';
import FJActionModal from '../../redux/action/FJActionModal';
import FJMobileObjectEraseEditFooterContainer from './FJMobileObjectEraseEditFooter/FJMobileObjectEraseEditFooterContainer';
import FJMobileCreationEditContainer from '../FJMobileImageManipulation/FJMobileCreationEdit/FJMobileCreationEdit.container';
import { setSliceMobileCanDraw } from '../../redux/slices/FJSliceBrushEditCommon';
import FJMobileGenerateSuccessfulContainer from '../FJMainPreview/FJMobileGenerateSuccessful/FJMobileGenerateSuccessfulContainer';
import { setSliceTaskStatusAction } from '../../redux/slices/FJSliceCommon';
import FJConstant from '../../constants/FJConstant';
import FJLocalStore from '../../store/FJLocalStore';
import { useMemo } from 'react';

const FJMobileObjectErase = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const inputImageInfo = useSelector(state => state.objectErase.inputImageInfo);
    const creationList = useSelector(state => state.common.creationList);

    useEffect(() => {
        dispatch(FJActionObjectErase.initObjectEraseProjectAction());
        // 始终可以编辑
        dispatch(setSliceMobileCanDraw(true));
    }, [dispatch]);
    const uploadImage = useCallback(
        file => {
            dispatch(FJActionObjectErase.uploadImageAction(file));

            const isFirstVisit = !localStorage.getItem('hasVisitedBefore');
            if (isFirstVisit) {
                localStorage.setItem('hasVisitedBefore', 'true');
                dispatch(FJActionModal.showAutoSelectionNoticeModalAction());
            }
        },
        [dispatch],
    );
    const _gotoBack = useCallback(() => {
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
    }, [dispatch]);
    const onReEdit = useCallback(
        file => {
            dispatch(FJActionObjectErase.uploadImageAction(file));
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        },
        [dispatch],
    );

    const imageRect = useMemo(
        () => ({ width: inputImageInfo?.width, height: inputImageInfo?.height }),
        [inputImageInfo],
    );
    const hasUploadedImg = inputImageInfo && inputImageInfo.src;
    const title = 'ai-object-eraser-colorful',
        description = 'quickly-remove-unwanted-objects-using-ai';
    return (
        <>
            {!hasUploadedImg && (
                <FJMobileDefaultPreview
                    title={title}
                    description={description}
                    uploadImg={uploadImage}
                    videoSrc={FJConfig.notImageBoxVideoUrl}
                />
            )}
            {hasUploadedImg && (
                <>
                    <FJMobileGenerateSuccessfulContainer
                        gotoBack={_gotoBack}
                        onReEdit={onReEdit}
                        previewList={creationList}
                        reEditText={FJLocalStore._('remove-more')}
                        imageRect={imageRect}
                    />
                    <FJMobileCreationEditContainer containerHeight={'calc(100% - 284px)'} />
                    <FJMobileObjectEraseEditFooterContainer />
                </>
            )}

            <FJMobileHistoryContainer />
        </>
    );
};
export default FJMobileObjectErase;
